import React from "react";
import "../styles/legal.css";

export default function TermsPage() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Terms of Service</h1>
        <p>Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing and using Afriport, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>
            Permission is granted to temporarily download one copy of the materials (information or software) on Afriport for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul>
            <li>Modifying or copying the materials</li>
            <li>Using the materials for any commercial purpose or for any public display</li>
            <li>Attempting to decompile or reverse engineer any software contained on the platform</li>
            <li>Removing any copyright or other proprietary notations from the materials</li>
            <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
            <li>Engaging in any conduct that restricts or inhibits anyone's use or enjoyment of the website</li>
          </ul>
        </section>

        <section>
          <h2>3. Disclaimer</h2>
          <p>
            The materials on Afriport's website are provided on an 'as is' basis. Afriport makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>
        </section>

        <section>
          <h2>4. Limitations</h2>
          <p>
            In no event shall Afriport or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Afriport, even if Afriport or an authorized representative has been notified orally or in writing of the possibility of such damage.
          </p>
        </section>

        <section>
          <h2>5. Accuracy of Materials</h2>
          <p>
            The materials appearing on Afriport could include technical, typographical, or photographic errors. Afriport does not warrant that any of the materials on the website are accurate, complete, or current. Afriport may make changes to the materials contained on the website at any time without notice.
          </p>
        </section>

        <section>
          <h2>6. Links</h2>
          <p>
            Afriport has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Afriport of the site. Use of any such linked website is at the user's own risk.
          </p>
        </section>

        <section>
          <h2>7. Modifications</h2>
          <p>
            Afriport may revise these terms of service for the website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of Nigeria, and you irrevocably submit to the exclusive jurisdiction of the courts located in Nigeria.
          </p>
        </section>

        <section>
          <h2>9. User Conduct</h2>
          <p>
            You agree that you will not:
          </p>
          <ul>
            <li>Upload, post, or transmit any unlawful, threatening, abusive, defamatory, obscene, or otherwise objectionable material</li>
            <li>Engage in any conduct that restricts or inhibits anyone's use or enjoyment of the website</li>
            <li>Attempt to gain unauthorized access to the website or its systems</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Engage in spamming or flooding the website with unsolicited messages</li>
          </ul>
        </section>

        <section>
          <h2>10. Seller Responsibilities</h2>
          <p>
            Sellers on Afriport agree to:
          </p>
          <ul>
            <li>Provide accurate product descriptions and pricing</li>
            <li>Maintain adequate stock levels</li>
            <li>Fulfill orders promptly and professionally</li>
            <li>Comply with all applicable laws and regulations</li>
            <li>Not engage in fraudulent or deceptive practices</li>
          </ul>
        </section>

        <section>
          <h2>11. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at support@afriportb2c.online
          </p>
        </section>
      </div>
    </div>
  );
}
